<template>
  <div>
    <b-tabs
      pills
      fill
    >
      <b-tab active>
        <template #title>
          <feather-icon icon="FileTextIcon" />
          <span>Proforma Fatura Bilgileri</span>
        </template>
        <validation-observer ref="simpleRules">
          <proforma-form
            :submit-form="submitForm"
            :submit-status="submitStatus"
            :remove-item="removeItem"
            :add-items="getProductList"
          />
        </validation-observer>
      </b-tab>
      <b-tab lazy>
        <template #title>
          <feather-icon icon="UserIcon" />
          <span>Müşteri Bilgileri</span>
        </template>
        <customer-info />
        <customer-invoice />
      </b-tab>
      <b-tab lazy>
        <template #title>
          <feather-icon icon="ClockIcon" />
          <span>Müşteri Geçmişi</span>
        </template>
        <customer-history :customer-id="this.$route.params.id_customers" />
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import {
  BTabs, BTab,
} from 'bootstrap-vue'
import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import ProformaForm from '@/views/Admin/Proforma_invoices/ProformaForm.vue'
import CustomerInfo from '@/views/Admin/Customers/View/CustomerInfo.vue'
import CustomerInvoice from '@/views/Admin/Customers/View/CustomerInvoice.vue'
import CustomerHistory from '@/views/Admin/Customers/View/CustomerHistory.vue'
// eslint-disable-next-line import/extensions
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  name: 'Add',
  components: {
    BTabs,
    BTab,
    ProformaForm,
    CustomerInfo,
    CustomerInvoice,
    CustomerHistory,
    ValidationObserver,
  },
  data() {
    return {
      required,
      submitStatus: false,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['proformaInvoices/dataItem']
    },
    dataList() {
      return this.$store.getters['proformaInvoices/productList']
    },
    saveData() {
      return this.$store.getters['proformaInvoices/dataSaveStatus']
    },
    offerData() {
      return this.$store.getters['offerLines/dataList']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.$router.push(`/app/proforma-invoices/view/${val.id}`)
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
    },
  },
  created() {
    this.$store.commit('proformaInvoices/RESET_DATA_ITEM')
    this.$store.commit('proformaInvoices/RESET_PRODUCT_DATA')
    this.$store.commit('customers/SET_DATA_ITEM')

    this.getProformaData()
    this.getOfferData()
    localize('tr')
  },
  methods: {
    getCustomer(index) {
      this.$store.dispatch('customers/getDataItem', index)
    },
    getCustomerRelatedPerson(index) {
      this.$store.dispatch('customerRelatedPersons/getDataList', {
        where: {
          'customer_related_persons.id_customers': index,
        },
      })
    },
    getProformaData() {
      this.$store.dispatch('offers/getDataItem', { id: this.$route.params.id })
        .then(response => {
          if (response) {
            this.dataItem.id_customers = response.id_customers
            this.dataItem.totalPrice = response.totalPrice
            this.dataItem.discount_amount = response.discount_amount
            this.dataItem.discount_rate = response.discount_rate
            this.getCustomer(response.id_customers)
            this.getCustomerRelatedPerson(response.id_customers)
            this.getCurrency(response.id_currencies)
            this.getProductList()
          }
        })
    },
    getOfferData() {
      return this.$store.dispatch('offerLines/getDataList', {
        where: {
          'offer_lines.id_offers': this.$route.params.id,
        },
        proform: true,
      })
    },
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          let processError = false
          this.dataItem.proforma_lines = []
          for (let i = 0; i < this.dataList.length; i += 1) {
            for (let l = 0; l < this.dataList[i].productList.length; l += 1) {
              if (!this.dataList[i].productList[l].id_units) {
                this.showToast({
                  variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: 'Lütfen "Birim" alanlarını doldurduğunuzdan emin olun.',
                })
                processError = true
                break
              } else {
                delete this.dataList[i].productList[l].id
              }
              this.dataItem.proforma_lines.push(this.dataList[i].productList[l])
            }
          }
          this.dataItem.id_offers = this.$route.params.id
          if (!processError) {
            this.$store.dispatch('proformaInvoices/saveData', this.dataItem)
          }
        }
      })
    },

    getCurrency(index) {
      this.$store.dispatch('currencies/getDataItem', index)
    },
    removeItem(itemId, productType, index) {
      if (this.dataList.length > 0) {
        this.dataList[productType].productList.splice(index, 1)
      }
    },
    getProductList(proformaId = null) {
      this.$store.dispatch('proformaInvoices/getProductList', {
        id_proforma_invoices: proformaId || this.dataItem.id,
        id_offers: this.$route.params.id,
        addOffer: true,
      })
    },
    getProjectData() {
      this.$store.dispatch('projects/getDataItem', this.$route.params.id_projects)
        .then(response => {
          if (response) {
            this.dataItem.id_customers = response.id_customers
            this.getCustomer(response.id_customers)
            this.getCurrency(response.id_currencies)
          }
        })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
